var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-info-wrapper" },
    [
      _c(
        "ul",
        {
          staticClass: "accordion accordion-customize",
          attrs: {
            id: "contact-info-accordion",
            "data-accordion": "",
            "data-deep-link": "true",
            "data-allow-all-closed": "true",
            "data-multi-expand": "true",
            "data-update-history": "true",
            "data-deep-link-smudge": "500",
          },
        },
        [
          _c(
            "li",
            {
              staticClass: "accordion-item is-active",
              attrs: { "data-accordion-item": "" },
            },
            [
              _c("a", { staticClass: "accordion-title" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("contact.contactInfo")))]),
                _vm._v(" "),
                !_vm.isCreatePage
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "accordion-title__histories name-hyper-link float-right",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.$refs.updateHistoriesModal.open.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("tenancy.changeHistory")) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "accordion-content",
                  attrs: { "data-tab-content": "" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _vm._l(
                        _vm.getFullnameSorts,
                        function (fullnameObj, index) {
                          return _c(
                            "div",
                            {
                              key: "fullname_" + index,
                              staticClass:
                                "input-set small-3 medium-3 large-3 column",
                              class: fullnameObj.isFirst
                                ? "first-name"
                                : "last-name",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "emphasis",
                                  class: {
                                    "required-flag":
                                      _vm.allowEdit &&
                                      fullnameObj.label === "firstName",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "contact.basic." +
                                            (fullnameObj.label === "firstName"
                                              ? "firstGroupName"
                                              : fullnameObj.label)
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.allowEdit
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "hkldinput",
                                        rawName: "v-hkldinput",
                                      },
                                      {
                                        name: "fusioninputcheck",
                                        rawName: "v-fusioninputcheck",
                                        value:
                                          fullnameObj.label === "firstName"
                                            ? {
                                                type: "string",
                                                tip: _vm.$t(
                                                  "hint.inputTip.string"
                                                ),
                                                classes: "tooltip-class",
                                              }
                                            : { required: false },
                                        expression:
                                          "fullnameObj.label === 'firstName' ? {\n                type: 'string',\n                tip: $t('hint.inputTip.string'),\n                classes: 'tooltip-class'\n              } : { required: false }",
                                      },
                                    ],
                                    attrs: {
                                      type: "text",
                                      required:
                                        fullnameObj.label === "firstName",
                                    },
                                    domProps: {
                                      value:
                                        _vm.currentContact[fullnameObj.value],
                                    },
                                    on: {
                                      change: function (event) {
                                        return _vm.updatePathField(
                                          fullnameObj.value,
                                          event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.allowEdit
                                ? _c("div", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.currentContact[fullnameObj.value]
                                        ) +
                                        "\n            "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        }
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "prefix input-set small-2 medium-2 large-2 column",
                        },
                        [
                          _c("label", { staticClass: "emphasis" }, [
                            _vm._v(_vm._s(_vm.$t("contact.basic.prefix"))),
                          ]),
                          _vm._v(" "),
                          _vm.allowEdit
                            ? _c("HKLSelect", {
                                attrs: {
                                  value: _vm.currentContact.prefix || undefined,
                                  options: _vm.prefixHklOptions,
                                  showSearch: true,
                                  placeholder: "",
                                },
                                on: {
                                  change: function (val) {
                                    return _vm.updatePathField("prefix", val)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.allowEdit
                            ? _c("div", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.customPrefixLabel(
                                        _vm.currentContact.prefix
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.isEngineer
                    ? _c(
                        "div",
                        { staticClass: "remarks-block" },
                        [
                          _c("label", { staticClass: "emphasis" }, [
                            _vm._v(_vm._s(_vm.$t("contact.basic.remarks"))),
                          ]),
                          _vm._v(" "),
                          _c("TextField", {
                            directives: [
                              { name: "hkldinput", rawName: "v-hkldinput" },
                            ],
                            attrs: {
                              value:
                                _vm.currentContact.remarks ||
                                (_vm.allowEdit ? "" : _vm.emptyValue),
                              readonly: !_vm.allowEdit,
                            },
                            on: {
                              updateValue: function (val) {
                                return _vm.updatePathField("remarks", val)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "table-section",
                      class: {
                        "error-highlight-background":
                          _vm.inputRequireHighlight || _vm.highlightPhone,
                      },
                    },
                    [
                      _c("table", { staticClass: "contacts-table" }, [
                        _c("thead", [
                          _c("tr", [
                            _c("th", { staticClass: "selct-column" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("contact.phone.primaryPhone")) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "number-column" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("contact.phone.phoneNumber")) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "type-column" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("contact.phone.phoneType")) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "remove-column" }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            _vm._l(
                              _vm.currentContact.phoneNumbers,
                              function (item, index) {
                                return _vm.currentContact.phoneNumbers
                                  .length !== 0
                                  ? _c("tr", { key: index }, [
                                      _c(
                                        "td",
                                        { staticClass: "selct-column" },
                                        [
                                          _c("input", {
                                            attrs: {
                                              type: "radio",
                                              name: "phoneNumbers",
                                              disabled: !_vm.allowEdit,
                                            },
                                            domProps: {
                                              checked: item.priority
                                                ? "checked"
                                                : "",
                                            },
                                            on: {
                                              change: function (event) {
                                                return _vm.updateContactInfo(
                                                  "phoneNumbers",
                                                  index,
                                                  ["priority"],
                                                  !item.priority
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "number-column" },
                                        [
                                          _vm.allowEdit
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "hkldinput",
                                                    rawName: "v-hkldinput",
                                                  },
                                                  {
                                                    name: "fusioninputcheck",
                                                    rawName:
                                                      "v-fusioninputcheck",
                                                    value: {
                                                      type: "string",
                                                      pattern: _vm.regex.phone,
                                                      classes: "tooltip-class",
                                                      tip: _vm.tips.phone,
                                                      required: true,
                                                    },
                                                    expression:
                                                      "{\n                      type: 'string',\n                      pattern: regex.phone,\n                      classes: 'tooltip-class',\n                      tip: tips.phone,\n                      required: true\n                    }",
                                                  },
                                                ],
                                                attrs: { type: "text" },
                                                domProps: { value: item.value },
                                                on: {
                                                  change: function (event) {
                                                    return _vm.updatePathArrayField(
                                                      "phoneNumbers",
                                                      index,
                                                      ["value"],
                                                      event.target.value
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.allowEdit
                                            ? _c("div", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(item.value || "--") +
                                                    "\n                  "
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "type-column" },
                                        [
                                          _vm.allowEdit
                                            ? _c("HKLSelect", {
                                                attrs: {
                                                  value:
                                                    _vm.deep(
                                                      item,
                                                      "typeRemark"
                                                    ) || undefined,
                                                  options:
                                                    _vm.phoneTypeHklOptions,
                                                  showSearch: true,
                                                  placeholder: "",
                                                },
                                                on: {
                                                  change: function (val) {
                                                    return _vm.updatePathArrayField(
                                                      "phoneNumbers",
                                                      index,
                                                      ["typeRemark"],
                                                      val
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.allowEdit
                                            ? _c("div", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.customContactType(
                                                        item.typeRemark
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ])
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "icon-remove" }, [
                                        _vm.allowEdit
                                          ? _c("i", {
                                              staticClass: "fa fa-times-thin",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openDeleteConfirm(
                                                    "phoneNumbers",
                                                    index
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]),
                                    ])
                                  : _vm._e()
                              }
                            ),
                            _vm._v(" "),
                            _vm.currentContact.phoneNumbers.length === 0 &&
                            !_vm.allowEdit
                              ? _c("tr", [
                                  _c("td", { staticClass: "selct-column" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.emptyValue) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "number-column" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.emptyValue) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "type-column" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.emptyValue) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "icon-remove" }),
                                ])
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.allowEdit
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn--round",
                              on: {
                                click: function ($event) {
                                  return _vm.addItem("phoneNumbers")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("contact.phone.addPhone")) +
                                  " +\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "table-section",
                      class: {
                        "error-highlight-background":
                          _vm.inputRequireHighlight || _vm.highlightEmail,
                      },
                    },
                    [
                      _c("table", { staticClass: "contacts-table" }, [
                        _c("thead", [
                          _c("tr", [
                            _c("th", { staticClass: "selct-column" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("contact.email.primaryEmail")) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "number-column" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("contact.email.emailAddr")) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "type-column" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("contact.email.emailType")) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "remove-column" }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            _vm._l(
                              _vm.currentContact.emails,
                              function (item, index) {
                                return _vm.currentContact.emails.length !== 0
                                  ? _c("tr", { key: index }, [
                                      _c(
                                        "td",
                                        { staticClass: "selct-column" },
                                        [
                                          _c("input", {
                                            attrs: {
                                              type: "radio",
                                              name: "emails",
                                              disabled: !_vm.allowEdit,
                                            },
                                            domProps: {
                                              checked: item.priority,
                                            },
                                            on: {
                                              change: function (event) {
                                                return _vm.updateContactInfo(
                                                  "emails",
                                                  index,
                                                  ["priority"],
                                                  !item.priority
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "number-column" },
                                        [
                                          _vm.allowEdit
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "hkldinput",
                                                    rawName: "v-hkldinput",
                                                  },
                                                  {
                                                    name: "fusioninputcheck",
                                                    rawName:
                                                      "v-fusioninputcheck",
                                                    value: {
                                                      type: "string",
                                                      pattern: _vm.regex.email,
                                                      classes: "tooltip-class",
                                                      tip: _vm.tips.email,
                                                      required: true,
                                                    },
                                                    expression:
                                                      "{\n                      type: 'string',\n                      pattern: regex.email,\n                      classes: 'tooltip-class',\n                      tip: tips.email,\n                      required: true\n                    }",
                                                  },
                                                ],
                                                attrs: { type: "text" },
                                                domProps: {
                                                  value: _vm.deep(
                                                    item,
                                                    "value"
                                                  ),
                                                },
                                                on: {
                                                  change: function (event) {
                                                    return _vm.updatePathArrayField(
                                                      "emails",
                                                      index,
                                                      ["value"],
                                                      event.target.value
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.allowEdit
                                            ? _c("div", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(item.value || "--") +
                                                    "\n                  "
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "type-column" },
                                        [
                                          _vm.allowEdit
                                            ? _c("HKLSelect", {
                                                attrs: {
                                                  value:
                                                    _vm.deep(
                                                      item,
                                                      "typeRemark"
                                                    ) || undefined,
                                                  options:
                                                    _vm.emailTypeHklOptions,
                                                  showSearch: true,
                                                  placeholder: "",
                                                },
                                                on: {
                                                  change: function (val) {
                                                    return _vm.updatePathArrayField(
                                                      "emails",
                                                      index,
                                                      ["typeRemark"],
                                                      val
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.allowEdit
                                            ? _c("div", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.customContactType(
                                                        item.typeRemark
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ])
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "icon-remove" }, [
                                        _vm.allowEdit
                                          ? _c("i", {
                                              staticClass: "fa fa-times-thin",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openDeleteConfirm(
                                                    "emails",
                                                    index
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]),
                                    ])
                                  : _vm._e()
                              }
                            ),
                            _vm._v(" "),
                            _vm.currentContact.emails.length === 0 &&
                            !_vm.allowEdit
                              ? _c("tr", [
                                  _c("td", { staticClass: "selct-column" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.emptyValue) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "number-column" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.emptyValue) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "type-column" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.emptyValue) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "icon-remove" }),
                                ])
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.allowEdit
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn--round",
                              on: {
                                click: function ($event) {
                                  return _vm.addItem("emails")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("contact.email.addEmail")) +
                                  " +\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "table-section",
                      class: {
                        "error-highlight-background": _vm.inputRequireHighlight,
                      },
                    },
                    [
                      _c("table", { staticClass: "contacts-table" }, [
                        _c("thead", [
                          _c("tr", [
                            _c("th", { staticClass: "selct-column" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("contact.fax.primaryFax")) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "number-column" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("contact.fax.fax")) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "type-column" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("contact.fax.faxType")) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "remove-column" }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            _vm.currentContact.faxNumbers.length !== 0
                              ? _vm._l(
                                  _vm.currentContact.faxNumbers,
                                  function (item, index) {
                                    return _c("tr", { key: index }, [
                                      _c(
                                        "td",
                                        { staticClass: "selct-column" },
                                        [
                                          _c("input", {
                                            attrs: {
                                              type: "radio",
                                              name: "faxNumbers",
                                              disabled: !_vm.allowEdit,
                                            },
                                            domProps: {
                                              checked: item.priority,
                                            },
                                            on: {
                                              change: function (event) {
                                                return _vm.updateContactInfo(
                                                  "faxNumbers",
                                                  index,
                                                  ["priority"],
                                                  !item.priority
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "number-column" },
                                        [
                                          _vm.allowEdit
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "hkldinput",
                                                    rawName: "v-hkldinput",
                                                  },
                                                  {
                                                    name: "fusioninputcheck",
                                                    rawName:
                                                      "v-fusioninputcheck",
                                                    value: {
                                                      type: "string",
                                                      pattern: _vm.regex.phone,
                                                      classes: "tooltip-class",
                                                      tip: _vm.tips.phone,
                                                      required: true,
                                                    },
                                                    expression:
                                                      "{\n                        type: 'string',\n                        pattern: regex.phone,\n                        classes: 'tooltip-class',\n                        tip: tips.phone,\n                        required: true\n                      }",
                                                  },
                                                ],
                                                attrs: { type: "text" },
                                                domProps: {
                                                  value: _vm.deep(
                                                    item,
                                                    "value"
                                                  ),
                                                },
                                                on: {
                                                  change: function (event) {
                                                    return _vm.updatePathArrayField(
                                                      "faxNumbers",
                                                      index,
                                                      ["value"],
                                                      event.target.value
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.allowEdit
                                            ? _c("div", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(item.value || "--") +
                                                    "\n                    "
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "type-column" },
                                        [
                                          _vm.allowEdit
                                            ? _c("HKLSelect", {
                                                attrs: {
                                                  value:
                                                    _vm.deep(
                                                      item,
                                                      "typeRemark"
                                                    ) || undefined,
                                                  options:
                                                    _vm.faxTypeHklOptions,
                                                  showSearch: true,
                                                  placeholder: "",
                                                },
                                                on: {
                                                  change: function (val) {
                                                    return _vm.updatePathArrayField(
                                                      "faxNumbers",
                                                      index,
                                                      ["typeRemark"],
                                                      val
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.allowEdit
                                            ? _c("div", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.customContactType(
                                                        item.typeRemark
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ])
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "icon-remove" }, [
                                        _vm.allowEdit
                                          ? _c("i", {
                                              staticClass: "fa fa-times-thin",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openDeleteConfirm(
                                                    "faxNumbers",
                                                    index
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]),
                                    ])
                                  }
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentContact.faxNumbers.length === 0 &&
                            !_vm.allowEdit
                              ? _c("tr", [
                                  _c("td", { staticClass: "selct-column" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.emptyValue) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "number-column" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.emptyValue) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "type-column" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.emptyValue) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "icon-remove" }),
                                ])
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.allowEdit
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn--round",
                              on: {
                                click: function ($event) {
                                  return _vm.addItem("faxNumbers")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("contact.fax.addFax")) +
                                  " +\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.allowEdit || _vm.currentContact.addresses.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "row table-section",
                          class: {
                            "error-highlight-background":
                              _vm.inputRequireHighlight,
                          },
                        },
                        [
                          _c(
                            "ul",
                            { staticClass: "address-list" },
                            _vm._l(
                              _vm.currentContact.addresses,
                              function (item, index) {
                                return _c(
                                  "li",
                                  {
                                    key: index,
                                    staticClass: "row",
                                    class: {
                                      "error-highlight-background":
                                        _vm.highlightAddressIndexes.includes(
                                          index
                                        ),
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "small-2 medium-2 large-2 column select-column",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-set" },
                                          [
                                            _c(
                                              "label",
                                              { staticClass: "emphasis" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "contact.address.primaryAddr"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              attrs: {
                                                type: "radio",
                                                name: "addresses",
                                                disabled: !_vm.allowEdit,
                                              },
                                              domProps: {
                                                checked: item.priority,
                                              },
                                              on: {
                                                change: function (event) {
                                                  return _vm.updateContactInfo(
                                                    "addresses",
                                                    index,
                                                    ["priority"],
                                                    !item.priority
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "small-10 medium-10 large-10 column",
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "emphasis" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "company.contact.addressLine"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "input-set" },
                                          [
                                            _c("div", { staticClass: "row" }, [
                                              _vm.allowEdit
                                                ? _c("input", {
                                                    directives: [
                                                      {
                                                        name: "hkldinput",
                                                        rawName: "v-hkldinput",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "text",
                                                      placeholder: _vm.$t(
                                                        "company.contact.addressLine1"
                                                      ),
                                                    },
                                                    domProps: {
                                                      value: _vm.deep(
                                                        item,
                                                        "value.addressLine1"
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (event) {
                                                        return _vm.updatePathArrayField(
                                                          "addresses",
                                                          index,
                                                          [
                                                            "value",
                                                            "addressLine1",
                                                          ],
                                                          event.target.value
                                                        )
                                                      },
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "icon-remove address-remove",
                                                },
                                                [
                                                  _vm.allowEdit
                                                    ? _c("i", {
                                                        staticClass:
                                                          "fa fa-times-thin",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openDeleteConfirm(
                                                              "addresses",
                                                              index
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            !_vm.allowEdit
                                              ? _c("div", [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.deep(
                                                          item,
                                                          "value.addressLine1"
                                                        ) || "--"
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "input-set" },
                                          [
                                            _vm.allowEdit
                                              ? _c("input", {
                                                  directives: [
                                                    {
                                                      name: "hkldinput",
                                                      rawName: "v-hkldinput",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    placeholder: _vm.$t(
                                                      "company.contact.addressLine2"
                                                    ),
                                                  },
                                                  domProps: {
                                                    value: _vm.deep(
                                                      item,
                                                      "value.addressLine2"
                                                    ),
                                                  },
                                                  on: {
                                                    change: function (event) {
                                                      return _vm.updatePathArrayField(
                                                        "addresses",
                                                        index,
                                                        [
                                                          "value",
                                                          "addressLine2",
                                                        ],
                                                        event.target.value
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.allowEdit
                                              ? _c("div", [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.deep(
                                                          item,
                                                          "value.addressLine2"
                                                        ) || "--"
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "input-set" },
                                          [
                                            _vm.allowEdit
                                              ? _c("input", {
                                                  directives: [
                                                    {
                                                      name: "hkldinput",
                                                      rawName: "v-hkldinput",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    placeholder: _vm.$t(
                                                      "company.contact.addressLine3"
                                                    ),
                                                  },
                                                  domProps: {
                                                    value: _vm.deep(
                                                      item,
                                                      "value.addressLine3"
                                                    ),
                                                  },
                                                  on: {
                                                    change: function (event) {
                                                      return _vm.updatePathArrayField(
                                                        "addresses",
                                                        index,
                                                        [
                                                          "value",
                                                          "addressLine3",
                                                        ],
                                                        event.target.value
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.allowEdit
                                              ? _c("div", [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.deep(
                                                          item,
                                                          "value.addressLine3"
                                                        ) || "--"
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "input-set" },
                                          [
                                            _vm.allowEdit
                                              ? _c("input", {
                                                  directives: [
                                                    {
                                                      name: "hkldinput",
                                                      rawName: "v-hkldinput",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    placeholder: _vm.$t(
                                                      "company.contact.addressLine4"
                                                    ),
                                                  },
                                                  domProps: {
                                                    value: _vm.deep(
                                                      item,
                                                      "value.addressLine4"
                                                    ),
                                                  },
                                                  on: {
                                                    change: function (event) {
                                                      return _vm.updatePathArrayField(
                                                        "addresses",
                                                        index,
                                                        [
                                                          "value",
                                                          "addressLine4",
                                                        ],
                                                        event.target.value
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.allowEdit
                                              ? _c("div", [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.deep(
                                                          item,
                                                          "value.addressLine4"
                                                        ) || "--"
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "input-set small-4 medium-4 large-4 column",
                                            },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "emphasis" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "contact.address.addrType"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.allowEdit
                                                ? _c("HKLSelect", {
                                                    attrs: {
                                                      value:
                                                        _vm.deep(
                                                          item,
                                                          "typeRemark"
                                                        ) || undefined,
                                                      options:
                                                        _vm.addressTypeHklOptions,
                                                      showSearch: true,
                                                      placeholder: "",
                                                    },
                                                    on: {
                                                      change: function (val) {
                                                        return _vm.updatePathArrayField(
                                                          "addresses",
                                                          index,
                                                          ["typeRemark"],
                                                          val
                                                        )
                                                      },
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.allowEdit
                                                ? _c("div", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.customContactType(
                                                            item.typeRemark
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                          _vm._v(" "),
                          _vm.allowEdit
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn--round",
                                  on: {
                                    click: function ($event) {
                                      return _vm.addItem("addresses")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t("contact.address.addAddr")
                                      ) +
                                      " +\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "updateHistoriesModal",
          attrs: {
            modalId: "contact-histories-modal",
            modalType: "large-modal",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-header",
              attrs: { slot: "modal-header" },
              slot: "modal-header",
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("tenancy.changeHistory")) + "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "contact-histories-modal__content",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _c("UpdateHistories", {
                attrs: { sourceId: _vm.contactId, sourceTable: "ccd_contacts" },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "Modal",
        { ref: "alertModal", attrs: { modalId: "action-not-allowed-alert" } },
        [
          _c(
            "div",
            {
              staticClass: "modal-pure-text",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _c("p", { staticClass: "font-bold" }, [
                _vm._v("\n        " + _vm._s(_vm.alertMessage) + "\n      "),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                on: { click: _vm.closeAlertModal },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("action.ok")) + "\n      ")]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "deleteConfirmModal",
        attrs: {
          modalId: _vm.delConfModalId,
          confirmTitle: _vm.confirmMessage,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }